import React, { Component } from 'react';
import '../css/App.css';
import AssignedModulesParentComponent from './AssignedModulesParentComponent';
import AssignedModulesChild1 from './AssignedModulesChild1';
import Collapse from "@kunukn/react-collapse";
import Sidenav from './Sidenav';
import axios from 'axios';
import API from '../config_api'

class UnitAssign extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            showList: true,
            highlightedHobby: false
        };
    }

    componentWillMount() {
        if (!localStorage.getItem('token')) {
            this.props.history.push('/')
        }
        if (this.props.location.state) {
            this.setState({ data: this.props.location.state.data })
            localStorage.setItem("models", JSON.stringify(this.props.location.state.data))
        }
        else {
            this.setState({ data: JSON.parse(localStorage.getItem("models")) })

        }

    }

    listSwitch = () => {
        this.setState(state => ({
          highlightedHobby: !state.highlightedHobby
        }));
      };
    mainView(data, i, params) {
        let models;
        console.log(data);
        models = params.models
        models.forEach((val, index) => {
            if (i === index) {
                data.module_ui_status = !data.module_ui_status
                // console.log(val)
            } else {
                val.module_ui_status = false
            }
        })
        this.setState(prevState => ({
            showList: !prevState.showList
          }));
        this.forceUpdate();

    }
    callAlert(topic){
        alert("First Completed Pre Requisite Topic "+topic)
    }
    starModule(data) {
        console.log(data);
        this.props.history.push('/overview', {data})    
    }
    makeStar(data,program_id){
        if(data.stared == '0'){
        data.stared ='1';
        this.forceUpdate()
        }else{
        data.stared ='0';
        this.forceUpdate()
        }
        let formData = new FormData();
        formData.append('user_id', localStorage.getItem('token'))
        formData.append('program_id', program_id);
       
     axios({
            method: 'post',
            url: API.MakeStar,
            data:formData, 
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            },
            mode: 'no-cors',
        })
            .then(res => {
                // if (res.data.status === 'success') {
                //     this.setState({ data: res.data.data.scalar })
                    
                // }
                // else {
                //     alert(res.data.message)
                // }
            });
    }
    render() {
console.log(this.props)
        return (

            <div className="">
                
                <Sidenav type={'second'} url={'back'} Push={this.props.history} />
                

                <div className="container" style={{marginTop:25}}>

                    <div className="row">
                        <div className="col-sm-12 pad_z">

                            {this.state.data.models.map((item, i) => {
                                return (
                                    <div className="row" style={{ margin: 10 }} key={i}>
                                        <AssignedModulesParentComponent
                                            ParentComponentTitle={item.model_name}
                                            UnitsCount={item.programs.length}
                                            index={i}
                                            lock={item.lock === "open" ? true :false}
                                            pre_req={item.pre_req}
                                            ui_open={item.module_ui_status}
                                            completed={item.completed}
                                            OnAlert ={() => this.callAlert(item.pre_req)}
                                            Onpress={() => this.mainView(item, i, this.state.data)}
                                        />
                                        
                                         <Collapse isOpen={item.module_ui_status}>
                                            {item.module_ui_status === true ?
                                                item.programs.map((data, index) =>
                                                    <div className="trans" key={index}>
                                                        <AssignedModulesChild1
                                                            PreCompleted ={index === 0 ? "" :item.programs[index-1]}
                                                            index={index}
                                                            greenDot={data.completed}
                                                            isOffline={data.is_offline}
                                                            alwaysOpen={index === 0 ? true :false}
                                                            squential={item.sequential_lock === "open" ? true :false}
                                                            program_id={data.program_id}
                                                            SingleAlphabet={data.program_title.charAt(0)}
                                                            ChildComponent1content={data.program_title}
                                                            onPress={() => this.btnAction(data, data.model_name)}
                                                            stared={data.stared}
                                                            makeStar={() =>this.makeStar(data,data.program_id)}
                                                            starUnit={() => this.starModule(data, data.program_id)}
                                                        /></div>
                                                ) : ''}</Collapse>
                                    </div>
                                )
                            })
                            }


                        </div>
                    </div>

                </div>
            </div>
        );
    }
}

export default UnitAssign;